import React from "react";
import { ModalProps } from "react-bootstrap";
import "./index.css";

const Modal: React.FC<ModalProps> = ({ open, children, cssClasses }) => {
	if (!open) {
		return null;
	}
	return (
		<>
			<div className="overlayPopUp"></div>
			<div className={cssClasses}>
                {children}				
			</div>
		</>
	);
};

export default Modal;
